
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/[id]",
      function () {
        return require("private-next-pages/login/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/[id]"])
      });
    }
  